import { render, staticRenderFns } from "./control6Setup.vue?vue&type=template&id=50771f77&scoped=true&"
import script from "./control6Setup.vue?vue&type=script&lang=js&"
export * from "./control6Setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50771f77",
  null
  
)

export default component.exports